import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backButton", "backLabel", "cancelButton", "cancelLabel", "doneButton", "doneLabel", "hidePrimaryControls", "hideSecondaryControls", "isFirstStep", "isLastStep", "nextButton", "nextLabel"];
import { DialogBody } from '../DialogBody';
import { usePanelContext } from '../../context/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardStep = _ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    inPanel
  } = usePanelContext();
  return /*#__PURE__*/_jsx(DialogBody, Object.assign({
    paddingBlockStart: inPanel ? '500' : '1000',
    paddingBlockEnd: "1000"
  }, rest));
};
WizardStep.displayName = 'WizardStep';